<template>
  <div id="app">
    <vue-editable-grid
      class="grid"
      ref="grid"
      id="mygrid"
      :column-defs="columnDefs"
      :row-data="rows"
      row-data-key='id'
      @cell-updated="cellUpdated"
      @row-selected="rowSelected"
      @multiple-selected='multipleSelected'
      @link-clicked="linkClicked"
      @context-menu="contextMenu"
    >
      <template v-slot:header>
        Vue editable grid, by eledwinn
        <a href="#" @click.prevent="removeCurrentRow" v-if="selectedRow" class="ml-1">Remove current row</a>
      </template>
      <template v-slot:header-r>
        Total rows: {{ rows.length }}
      </template>
    </vue-editable-grid>
  </div>
</template>

<script>
//import VueEditableGrid from './components/VueEditableGrid.vue'
import VueEditableGrid from 'vue-editable-grid'

import member from '@/services/member';
import icare from '@/services/icare'

import store from '@/store.js'

import data from './data'

export const defaultDateFormat = 'MMM dd, yyyy'
export const defaultDateTimeFormat = 'MMM dd, yyyy h:mm a'

const numericFormatter = event => {
  // if (event.reverse) {
  //   return event.value && +event.value.replace(' years')
  // }
  return `${event.value} years`
}



var selectOptions = [
    { value: 'male', text: 'MALEX' },
  { value: 'female', text: 'FEMALEX' }
]

var selectOptions1 = [

]



const format = event => {
return '123'
}

const columnDefinition = [
    { sortable: true, filter: true, field: 'id', headerName: 'id', editable: true },
    { sortable: true, filter: true, field: 'uuid', headerName: 'uuid', editable: true },
    { sortable: true, filter: true, field: 'firstname', headerName: 'firstname', editable: true },
    { sortable: true, filter: true, field: 'lastname', headerName: 'lastname', editable: true },
    { sortable: true, filter: true, field: 'email', headerName: 'email', editable: true },
    { sortable: true, filter: true, field: 'address1', headerName: 'address1', editable: true },
    { sortable: true, filter: true, field: 'address2', headerName: 'address2', editable: true },
    { sortable: true, filter: true, field: 'sex', headerName: 'sex', editable: true, type: 'select', selectOptions: selectOptions},
    { sortable: true, filter: false, field: 'is_active', headerName: 'Detail', type: 'link', editable: false},
    { sortable: true, filter: true, field: 'icare_id', headerName: 'icare_id', editable: true, type: 'select', selectOptions: selectOptions1},
//   { sortable: true, filter: true, field: 'id', headerName: 'Id', editable: true },
//   { sortable: true, filter: true, field: 'eyeColor', headerName: 'Eye color', editable: true, type: 'select', selectOptions: selectOptions },
//   { sortable: true, filter: true, field: 'name', headerName: 'Name', editable: true, maxlength: 5, className: 'my-custom-class' },
//   { sortable: true, filter: true, field: 'gender', headerName: 'gender', editable: true },
//   { sortable: true, filter: true, field: 'company', headerName: 'Company', editable: true },
//   { sortable: true, filter: true, field: 'email', headerName: 'Email', editable: true },
//   { sortable: true, filter: true, field: 'Phone', headerName: 'Phone', editable: true },
//   { sortable: true, filter: true, field: 'registered', headerName: 'registered', type: 'datetime', format: defaultDateTimeFormat, editable: true },
//   { sortable: true, filter: true, field: 'registered', headerName: 'registered', type: 'date', format: defaultDateTimeFormat, editable: true, min: '2020-12-01', max: '2021-01-15' },
//   { sortable: true, filter: true, field: 'age', headerName: 'Age', type: 'numeric', editable: true, min: 1, max: 100 },
//   { sortable: true, filter: true, field: 'age', headerName: 'Age Formatted', type: 'numeric', editable: true, formatter: numericFormatter },
//   { sortable: true, filter: true, field: 'balance', headerName: 'Balance', type: 'currency', editable: true },
//   { sortable: true, filter: true, field: 'happiness', headerName: 'Happiness percent', type: 'percent', editable: true },
//   { sortable: true, filter: true, field: 'isActive', headerName: 'Is active', type: 'boolean', editable: true },
//   { sortable: true, filter: false, field: 'picture', headerName: 'Picture', type: 'link', editable: false }
]

export default {
  name: 'App',
  components: {
    VueEditableGrid
  },
  data () {
    return {
      columnDefs: columnDefinition,
      rows: [],
      options:[],
      form:{
          firstname:'',
          lastname:'',
          email:'',
          address1:'',
          address2:'',
          sex:'',
          icare_id:''
      },
      selectedRow: null
    }
  },
  created () {
    //this.formatData()
    this.loadData()
    console.log(store.state.user.authenticated.email)
    //if(store.state.user.authenticated.email == 'andrew.sulindra@gmail.com'){this.loadData()}
  },
  mounted () {
    // you can call methods this.$refs.grid.getFormattedRows()
  },
  methods: {

     loadData() {
         console.log(data)
      let current_page = this.search == '' ? this.current_page:1
      var params = {
        page: 1,
        per_page: 1000,
        search: '',
        sortby: 'name',
        sortbydesc: 'ASC',
        is_active: 1,
      }
      member.getMemberDataSource(params)
      .then(res => {
          let getData = res.data.message
          console.log(res.data.data)
          this.rows = res.data.data
        //   this.items = getData.data
          //this.rows = getData
          //this.is_active = res.is_active
      }).catch ((err) => {
          alert('err')
        // var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        // EventBus.$emit('OPEN_MODAL_ALERT', params)
      })


    this.options = []
    icare.getIcare()
    .then(res => {
      for (let i=0; i <= res.data.length-1; i++){
        //alert
        selectOptions1.push({text: res.data[i].name, value:res.data[i].id})
        this.options.push({text: res.data[i].name, value:res.data[i].id})
      }
    }).catch((er) =>{
      alert('err')
    })  



     },

    formatData () {
      data.forEach(row => {
        this.formatRow(row)
      })
      this.rows = data
    },
    formatRow (row) {
      const red = '#ffe5e5'
      const green = '#b6f7b6'
      const { happiness } = row
      const priceRateBgColor = happiness > 0.6 ? green : red
      row.$cellStyle = {
        happiness: priceRateBgColor && { backgroundColor: priceRateBgColor }
      }
      if (row.eyeColor === 'blue') {
        row.$rowStyle = { color: 'blue' }
      }
    },
    cellUpdated ($event) {
        $event.markAsPending()
      console.log($event)
      console.log($event.value)
      console.log($event.row.uuid)
      console.log($event.row.email)
      console.log($event.column.field)


      //console.log($event.rowData)
//$event.confirm()

// if($event.value === 'asd'){
//     $event.markAsFailed('Invalid format')
// }else{
//     $event.markAsSuccess()
//     $event.confirm()
// }



//$event.$rowStyle = { color: 'blue' }

// this.rows = this.rows.$rowStyle = { color: 'blue' }

      //if($event.column.field == 'email'){this.form.email = $event.value}  
      this.form.firstname = $event.row.firstname
      this.form.lastname = $event.row.lastname
      this.form.email = $event.row.email
      this.form.address1 = $event.row.address1
      this.form.address2 = $event.row.address2
      this.form.sex = $event.row.sex

      if($event.column.field == 'firstname'){this.form.firstname = $event.value} 
      if($event.column.field == 'lastname'){this.form.lastname = $event.value} 
      if($event.column.field == 'email'){this.form.email = $event.value} 
      if($event.column.field == 'address1'){this.form.address1 = $event.value} 
      if($event.column.field == 'address2'){this.form.address2 = $event.value} 
      if($event.column.field == 'sex'){this.form.sex = $event.value}  
      if($event.column.field == 'icare_id'){this.form.icare_id = $event.value}  

      member.updateMember($event.row.uuid, this.form)
      .then(res => {
          console.log(res.message)
            $event.markAsSuccess()
            $event.confirm()
      }).catch ((err) => {
        console.log(err.response.data.message)
        $event.markAsFailed(err.response.data.message)
        //this.$router.go(0);
      })



    },
    rowSelected ($event) {
      this.selectedRow = $event.rowData
    },
    multipleSelected ($event) {
      console.log('Multiple selected', $event)
    },
    linkClicked ($event) {
      console.log($event)
      console.log($event.rowData.uuid)

      let routeData = this.$router.resolve({path: '/member/member_detail',query: {Pud:$event.rowData.uuid} }) 
      window.open(routeData.href, '_blank');

    },
    removeCurrentRow () {
      this.rows = this.rows.filter(row => row.id !== this.selectedRow.id)
    },
    contextMenu ($event) {
      console.log($event)
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-size: 14px;
  height: 800px;
}

.grid {
  height: 100%;
}

.ml-1 {
  margin-left: 10px;
}

.my-custom-class
.header-content{
  color: red;

  &::before {
    content: '*';
  }
}
</style>
